import { connect } from 'react-redux';
import TicketFormDetail from '../../components/form/ticket-form-detail';
import {
  saveTicket,
  createTicket,
  getTicket,
  addComment,
  resetTicketSuccess,
  getCategoryInfo,
  getCommentsByTicketId,
  getTicketActionTypes,
  snoozeTicketRequest,
} from './ticket-form-actions';
import {
  fetchRestrictedUsers,
  clearUsersData,
} from '../../../common/users/containers/users-dropdown-actions';
import { changeNavigationContext } from '../../../common/navigation/containers/navigation-actions';

const mapStateToProps = (state) => {
  const {
    ticketForm: {
      isNew,
      priorities,
      statuses,
      ticket,
      categoryInfo,
      categories,
      tags,
      comments,
      context,
      isLoading,
      isCommentsLoading,
      error,
      success,
      isSaving,
      linkedSourceObject,
      linkedEntities,
      ticketWatchers,
      addCommentSuccess,
      isSnoozing,
      snoozeSuccess,
      snoozeFailure,
    },
    smartAction,
    users: { users, loading },
  } = state;

  return {
    isNew,
    priorities,
    statuses,
    categories,
    categoryInfo,
    ticket,
    tags,
    comments,
    context,
    isLoading,
    isCommentsLoading,
    error,
    success,
    isSaving,
    linkedSourceObject,
    linkedEntities,
    ticketWatchers,
    saveSmartActionSuccess: smartAction.success,
    deleteSmartActionSuccess: smartAction.deleteSuccess,
    users,
    isLoadingUsers: loading,
    addCommentSuccess,
    isSnoozing,
    snoozeSuccess,
    snoozeFailure,
  };
};

const mapDispatchToProps = {
  saveTicket,
  createTicket,
  getTicket,
  addComment,
  resetTicketSuccess,
  getCategoryInfo,
  getCommentsByTicketId,
  getTicketActionTypes,
  fetchRestrictedUsers,
  clearUsersData,
  snoozeTicketRequest,
  changeNavigationContext,
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketFormDetail);
